import { z } from 'zod';
import { coerceNumber } from '../../../../validation';

export const PcpPersonalGoalSchema = z.object({
  id: coerceNumber(z.number()),
  name: z.string().min(1),
});

export type PcpPersonalGoal = z.infer<typeof PcpPersonalGoalSchema>;
